import { render, staticRenderFns } from "./RectificarIcon.vue?vue&type=template&id=aa0304b4&scoped=true"
var script = {}
import style0 from "./RectificarIcon.vue?vue&type=style&index=0&id=aa0304b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0304b4",
  null
  
)

export default component.exports